var generateComponentTheme = function generateComponentTheme(_ref) {
  var borders = _ref.borders,
    spacing = _ref.spacing,
    typography = _ref.typography,
    colors = _ref.colors;
  return {
    matchesBorder: borders.widthSmall,
    matchesPadding: spacing.xSmall,
    matchesColor: colors.slate,
    answerButtonTextPadding: spacing.xxSmall,
    answerButtonTextSize: typography.fontSizeSmall
  };
};
export default generateComponentTheme;